/**
 * @file Re-exports the InvestmentDrawer component.
 */
import InvestmentDrawer from "./InvestmentDrawer";

export default InvestmentDrawer;
